/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import DashboardControllerDtoGetDashboardDataDurationType from './DashboardControllerDtoGetDashboardDataDurationType';

/**
 * The DashboardControllerDtoGetDashboardDataRequest model module.
 * @module model/DashboardControllerDtoGetDashboardDataRequest
 * @version 1.0
 */
class DashboardControllerDtoGetDashboardDataRequest {
    /**
     * Constructs a new <code>DashboardControllerDtoGetDashboardDataRequest</code>.
     * @alias module:model/DashboardControllerDtoGetDashboardDataRequest
     */
    constructor() { 
        
        DashboardControllerDtoGetDashboardDataRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>DashboardControllerDtoGetDashboardDataRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DashboardControllerDtoGetDashboardDataRequest} obj Optional instance to populate.
     * @return {module:model/DashboardControllerDtoGetDashboardDataRequest} The populated <code>DashboardControllerDtoGetDashboardDataRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DashboardControllerDtoGetDashboardDataRequest();

            if (data.hasOwnProperty('duration')) {
                obj['duration'] = DashboardControllerDtoGetDashboardDataDurationType.constructFromObject(data['duration']);
            }
            if (data.hasOwnProperty('windowPeriodSeconds')) {
                obj['windowPeriodSeconds'] = ApiClient.convertToType(data['windowPeriodSeconds'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>DashboardControllerDtoGetDashboardDataRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>DashboardControllerDtoGetDashboardDataRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {module:model/DashboardControllerDtoGetDashboardDataDurationType} duration
 */
DashboardControllerDtoGetDashboardDataRequest.prototype['duration'] = undefined;

/**
 * @member {Number} windowPeriodSeconds
 */
DashboardControllerDtoGetDashboardDataRequest.prototype['windowPeriodSeconds'] = undefined;






export default DashboardControllerDtoGetDashboardDataRequest;

